// extracted by mini-css-extract-plugin
export default {"roomPointLabel":"RoomPoint_roomPointLabel__XqgBl","roomPointInput":"RoomPoint_roomPointInput__lN+pg","roomPointTextLabel":"RoomPoint_roomPointTextLabel__oi0CI"};